import React, { useEffect, useRef, useState } from "react";
import { Transition } from "react-transition-group";
import { TypeAnimation } from "react-type-animation";

import MenuListItem from "./MenuListItem";

const icon = new URL("../assets/images/icon-user-min.svg", import.meta.url);
let closeIcon = new URL("../assets/images/icon-close.svg", import.meta.url);

const duration = 300;
const defaultStyle = {
  transition: `all ${duration}ms ease-in-out`,
  opacity: 0,
};
const transitionStyles = {
  entered: { opacity: 1, height: "auto" },
  entering: { opacity: 1, height: "auto" },
  exiting: { opacity: 0, height: 0 },
  exited: { opacity: 0, height: 0 },
};
const transitionFirstStyles = {
  entered: { opacity: 1, height: "auto", marginTop: "50px" },
  entering: { opacity: 1, height: "auto", marginTop: "50px" },
  exiting: { opacity: 0, height: 0 },
  exited: { opacity: 0, height: 0 },
};

export default function UserDropdown({
  top = "200",
  onClose,
  showBookingForm,
}) {
  const [showFirstButton, setShowFirstButton] = useState(false);
  const [showSecondButton, setShowSecondButton] = useState(false);
  const nodeRefFirst = useRef(null);
  const nodeRefSecond = useRef(null);

  useEffect(() => {
    if (!showFirstButton) {
      return;
    }
    const tm = setTimeout(() => {
      setShowSecondButton(true);
    }, 600);

    return () => clearTimeout(tm);
  }, [showFirstButton]);

  return (
    <div
      className="bg-dark-blue p-6 text-dark-blue flex flex-col gap-3 absolute w-[90%] rounded-md z-50"
      style={{ top: `${top}px`, boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.25)" }}
    >
      <img
        src={closeIcon}
        alt="close"
        width="20"
        height="20"
        className="h-fit max-w-none cursor-pointer absolute p-1 right-2 top-2"
        onClick={onClose}
      />
      <div className="flex flex-col gap-1 items-center justify-center text-center text-white">
        <img src={icon} className="inline-block pr-2 pb-1" width={36} />
        <TypeAnimation
          cursor={false}
          sequence={["Välkommen till Fenix."]}
          speed={75}
          repeat={0}
        />
        <TypeAnimation
          cursor={false}
          sequence={[
            1300,
            "Vi hjälper dig att planera en fin och trygg begravning.",
            650,
            () => {
              setShowFirstButton(true);
            },
          ]}
          speed={75}
          repeat={0}
        />
      </div>
      <Transition
        nodeRef={nodeRefFirst}
        in={showFirstButton}
        timeout={duration}
      >
        {(state) => (
          <div
            className="flex flex-col gap-3"
            ref={nodeRefFirst}
            style={{
              ...defaultStyle,
              ...transitionFirstStyles[state],
            }}
          >
            <MenuListItem
              key={1}
              title="Läs mer om fenix och vår historia"
              bgColor="bg-yellow"
              textColor="text-dark-blue"
              darkArrow={true}
              link="https://fenixbegravning.se/om-fenix/"
            />
          </div>
        )}
      </Transition>
      <Transition
        nodeRef={nodeRefSecond}
        in={showSecondButton}
        timeout={duration}
      >
        {(state) => (
          <div
            className="flex flex-col gap-3"
            ref={nodeRefSecond}
            style={{
              ...defaultStyle,
              ...transitionStyles[state],
            }}
          >
            <MenuListItem
              key={2}
              title="boka ett möte eller ring oss direkt"
              bgColor="bg-yellow"
              textColor="text-dark-blue"
              darkArrow={true}
              onClickCallback={() => {
                showBookingForm(true);
                onClose();
              }}
            />
          </div>
        )}
      </Transition>
    </div>
  );
}
